import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import { fetchSssRequest } from "../../../api/sss";
import { formatCurrency } from "../../../helpers/functions/currency.js";
import moment from "moment";

class SSSDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                salaryFrom: null,
                salaryTo: null,
                employerShare: null,
                employeeShare: null,
                totalContribution: null,
                effectiveDate: null,
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchSss(instanceId)
        }
    }

    fetchSss = (id) => {
        fetchSssRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            salaryFrom,
            salaryTo,
            employerShare,
            employeeShare,
            totalContribution,
            isPercentage,
            percentageValue,
            effectiveDate,
            createdAt, 
            updatedAt
          } = this.state.resource;

        const calculatedTotalContribution = isPercentage 
            ? `${formatCurrency(salaryFrom * (percentageValue/100))} up to ${formatCurrency(salaryTo * (percentageValue/100))}`
            : formatCurrency(totalContribution);

        const calculatedEmployerShare = isPercentage 
            ? `${formatCurrency((salaryFrom * (percentageValue/100) / 2))} up to ${formatCurrency((salaryTo * (percentageValue/100) / 2))}`
            : formatCurrency(employerShare);
            
        const calculatedEmployeeShare = isPercentage 
            ? `${formatCurrency((salaryFrom * (percentageValue/100) / 2))} up to ${formatCurrency((salaryTo * (percentageValue/100) / 2))}`
            : formatCurrency(employeeShare);

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        SSS Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goBack()}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Salary From</p>
                            {formatCurrency(salaryFrom) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Salary To</p>
                            {formatCurrency(salaryTo) || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Percentage Value</p>
                            {isPercentage ? percentageValue + '%' : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employer Share</p>
                            {calculatedEmployerShare || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employee Share</p>
                            {calculatedEmployeeShare || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Total Contribution</p>
                            {calculatedTotalContribution || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Effective Date</p>
                            {effectiveDate ? moment(effectiveDate).format('MM/DD/YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('sss', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default SSSDetails;
